import { Box, Container } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { homePageTheme } from 'components/themes/theme';

export function ResearchHubHome() {
    return (
        <ThemeProvider theme={homePageTheme}>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                {/* Main Content Area - Empty as requested */}
                <Container
                    maxWidth={false}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        py: 4
                    }}
                >
                    {/* Research Hub content will go here in the future */}
                </Container>
            </Box>
        </ThemeProvider>
    );
}
